import React, { useState } from "react";
import "./headerPasos.css";

export default function HeaderPasos({ titulo, pasos = [], pasoInicial }) {
  const [pasoActivo, setPasoActivo] = useState(pasoInicial ?? pasos[0]?.id);

  const pasoSeleccionado = pasos.find((p) => p.id === pasoActivo);

  return (
    <div className="layout-pasos">
      {/* HEADER */}
      <header className="header-pasos">
        <nav className="menu-pasos">
          {pasos.map((paso, index) => (
            <button
              key={paso.id}
              className={`menu-btn ${pasoActivo === paso.id ? "activo" : ""}`}
              onClick={() => setPasoActivo(paso.id)}
            >
              <span className="paso-num">{index + 1}.</span>
              <span className="paso-text">{paso.label}</span>
            </button>
          ))}
        </nav>
      </header>

      {/* CONTENIDO */}
      <main className="contenido-pasos">{pasoSeleccionado?.component}</main>
    </div>
  );
}
